export const getDetection: (x: number) =>
  | {
      color: 'error' | 'success' | 'warning';
      percent: number;
      text: string;
    }
  | undefined = (amount: number) => {
  switch (true) {
    case amount === 0:
      return {
        color: 'error',
        percent: 0,
        text: 'очень низкая',
      };
    case amount < 3:
      return {
        color: 'error',
        percent: 33,
        text: 'низкая',
      };
    case amount < 5:
      return {
        color: 'warning',
        percent: 66,
        text: 'средняя',
      };
    case amount >= 5:
      return {
        color: 'success',
        percent: 100,
        text: 'высокая',
      };
  }
};
